//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import vComponent from '@/core/vComponent'
import { mapGetters } from 'vuex'
import { searchVipBar, funSticky } from './components'
import moment from 'moment'
export default {
  name: 'VipInfoPage',
  extends: vComponent,
  // components: { userInfo, searchVipBar },
  components: { searchVipBar, funSticky },
  data () {
    return {
      isShowCode: false, // 控制顯示qrcode
      info: null,
      isShowModal: false, // 是否顯示update modal,
      currentModal: { // 正在開啟update的欄位
        title: '',
        fieldName: '',
        val: ''
      },
      myLocale: {
        days: '星期日_星期一_星期二_星期三_星期四_星期五_星期六'.split('_'),
        daysShort: '日_一_二_三_四_五_六'.split('_'),
        months: '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split('_'),
        monthsShort: '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split('_'),
        firstDayOfWeek: 1
      },
      subPages: [
        { id: 'transaction', label: '交易', icon: 'dashboard' },
        { id: 'ticket', label: '兌換卷', icon: 'payment' }
        /* { id: 'report', label: '分析', icon: 'trending_up' },
        { id: 'tag', label: '註記', icon: 'edit' },
        { id: 'recommend', label: '推薦', icon: 'thumb_up' } */
      ],
      sexOptions: [
        { label: '男', value: 'M' },
        { label: '女', value: 'F' }
      ],
      levelOptions: [
        { label: '0', value: '0' },
        { label: '1', value: '1' },
        { label: '2', value: '2' },
        { label: '3', value: '3' }
      ],
      isShowRenew: false // 是否顯示update modal,
    }
  },
  computed: {
    ...mapGetters([
      'builderHost',
      'dateFormat',
      'site',
      'stock_no',
      'theme',
      'env',
      'siteConfig',
      'storeInfo'
    ]),
    userCheckDate () {
      return this.info && this.info.CHK_DATE !== null ? moment(this.info.CHK_DATE).format('YYYY/MM/DD') : ''
    },
    // 必須 storeInfo有levelConfig.BUFFER_MONTH 且user info 有CHK_DATE才會處理
    // 續約會員狀態 normal|willexpired|expired|downlevel
    renewStatus () {
      // let status = 'normal'
      const levelConfig = this.storeInfo.levelConfig
      let status = 'willexpired'
      if (this.info && this.info.CHK_DATE !== null && levelConfig && levelConfig.BUFFER_MONTH) {
        const chkdate = moment(this.info.CHK_DATE)
        // const chkdate = moment('2021-09-10') // 測試用
        // 判斷是否過期
        const isExpired = chkdate.isBefore(moment())
        // console.log(`chkdate=${chkdate} isExpired=${isExpired}`)
        if (isExpired) {
          // 已過期
          const bufferMonth = levelConfig.BUFFER_MONTH
          const bufferDate = chkdate.add(bufferMonth, 'months').add(1, 'days')
          const isAllowBuffer = bufferDate.isAfter(moment())
          console.log(`bufferDate=${bufferDate} bufferMonth=${bufferMonth} isAllowBuffer=${isAllowBuffer}`)
          if (isAllowBuffer) {
            status = 'expired'
          } else {
            status = 'downlevel'
          }
        } else {
          // 未過期
          const safeDate = moment(chkdate).subtract(1, 'months')
          const isBeforeSafe = safeDate.isBefore(moment())
          // console.log(`safeDate=${safeDate} isBeforeSafe=${isBeforeSafe}`)
          if (isBeforeSafe) {
            status = 'willexpired'
          } else {
            status = 'normal'
          }
        }
      }
      console.log(`status==${status}`)
      return status
    },
    renewColor () {
      let cls = ''
      switch (this.renewStatus) {
        case 'normal':
          cls = ''
          break
        case 'willexpired':
          cls = 'text-orange-8'
          break
        case 'expired':
          cls = 'text-red-6'
          break
        case 'downlevel':
          cls = 'text-grey-5'
          break
      }
      return cls
    },
    renewLabel () {
      let label = ''
      switch (this.renewStatus) {
        case 'willexpired':
          label = '即將過期'
          break
        case 'expired':
          label = '已經過期'
          break
      }
      return label
    },
    memberLevelLabel () {
      let label = ''
      if (this.info && this.info.MEMBER_LEVEL) label = this.getMemberLabel(this.info.MEMBER_LEVEL)
      return label
    }
  },
  async created () {
    this.levelOptions = [
      { label: this.getMemberLabel('0'), value: '0' },
      { label: this.getMemberLabel('1'), value: '1' },
      { label: this.getMemberLabel('2'), value: '2' },
      { label: this.getMemberLabel('3'), value: '3' }
    ]
    await this.getVipInfo()
  },
  mounted () {
    this.addHandler()
  },
  watch: {
  },
  methods: {
    moment,
    addHandler () {
      this.on('ReloadPage', async () => {
        await this.getVipInfo()
      })
      this.on('InfoPage.CMD_UpdateInfo', async () => {
        await this.getVipInfo()
      })
    },
    async getVipInfo () {
      const response = await this.fetch(`getVipInfo`, this.params.id_no, { SITE: this.site, VIP_CODE: this.params.vip_code })
      if (response.result === 'OK') {
        this.info = response.data
      } else {
        alert(response.msg)
      }
    },
    showUpdateModal (title, fieldName, val) {
      this.currentModal = { title, fieldName, val }
      this.isShowModal = true
    },
    async clickUpdate () {
      const data = {
        SITE: this.site,
        KEY: this.currentModal.fieldName,
        VALUE: this.currentModal.val
      }
      if (data.KEY === 'VIP_SEX' || data.KEY === 'MEMBER_LEVEL') data.VALUE = data.VALUE.value
      // 日期需將2002/01/01 轉成 20020101
      if (data.KEY === 'VIP_BIRTHDAY') {
        data.VALUE = moment(data.VALUE, 'YYYY/MM/DD').format('YYYYMMDD')
      }
      // siteConfig.METADATAS 判斷要更新的屬性是meta或是storevipmf
      let isMeta = false
      if (this.siteConfig.metadatas && this.siteConfig.metadatas.length > 0) {
        this.siteConfig.metadatas.forEach(item => {
          if (item.key === data.KEY) isMeta = true
        })
      }
      data.TYPE = isMeta ? 'meta' : 'storevipmf'
      // console.log(`click update data`)
      // console.log(data)
      const response = await this.fetch('updateVipInfo', this.params.id_no, data)
      // console.log(response)
      if (response.result === 'OK') {
        this.alert('更新完成')
        await await this.getVipInfo()
      } else {
        this.alert('更新失敗')
      }
    },
    showRenewModal () {
      this.isShowRenew = true
    },
    async clickRenew () {
      const keepMonth = this.storeInfo.levelConfig.KEEP_MONTH
      const chkdate = this.info.CHK_DATE !== null && this.info.CHK_DATE !== '' ? moment(this.info.CHK_DATE) : moment()
      const newChkDate = chkdate.add(keepMonth, 'months').format('YYYY-MM-DD')
      const data = { date: newChkDate }
      const response = await this.fetch('renew', this.site, this.params.id_no, data)
      if (response.result === 'OK') {
        this.alert(`續約${keepMonth}個月完成`)
        await await this.getVipInfo()
      } else {
        this.alert('續約失敗')
      }
    },
    alert (message) {
      this.$q.dialog({
        // title,
        message
      }).onOk(() => {
        this.isShowModal = false
        this.isShowRenew = false
      })
    },
    clickBtn (row, type) {
      // const url = `/vip/${row.ID_NO}/${type}`
      const url = type === 'transaction' ? `/vip/${row.ID_NO}/${type}/${row.VIP_CODE}` : `/vip/${row.ID_NO}/${type}`
      this.to(url)
    },
    // 由meta內取出值
    getMetaVal (key) {
      // 找出預設值 用不到
      /*
      let defaultVal = ''
      if (this.siteConfig.metadatas && this.siteConfig.metadatas.length > 0) {
        this.siteConfig.metadatas.forEach(item => {
          if (item.key === key) defaultVal = item.default
        })
      }
      */
      // 由meta取出值
      let val = ''
      if (this.info.meta && this.info.meta.length > 0) {
        this.info.meta.forEach(item => {
          if (item.KEY === key) val = item.VALUE
        })
      }
      // console.log(`key=${key} val=${val}`)
      return val
    },
    getMemberLabel (val) {
      let str = ''
      switch (val) {
        case '0':
          str = '一般會員'
          break
        case '1':
          str = '會員一'
          break
        case '2':
          str = '會員二'
          break
        case '3':
          str = '會員三'
          break
      }
      return str
    }
  }
}
